import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  templateItems: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 215,
  },
}))

export default styles
